import type { RouteCallback } from '@faceup/router'
import type {
  AdminMenuItem,
  AdminMenuSecondary,
  AdminMenuSection,
  AdminMenuSubItem,
} from './AdminMenu'

export const menuItemHeight = 48
export const menuItemGap = 2

export const isVisible = (entry: { visible?: boolean }) => entry.visible !== false

export const isSectionVisible = (section: AdminMenuSection) =>
  isVisible(section) && section.items.some(isVisible)

export const isNavigable = (
  item: AdminMenuSubItem
): item is AdminMenuSubItem & { link: RouteCallback } => isVisible(item) && Boolean(item.link)

const visibleSections = (secondary: AdminMenuSecondary) =>
  [...secondary.sections, ...(secondary.footerSections ?? [])].filter(isSectionVisible)

const hasSecondaryContent = (secondary: AdminMenuSecondary) => visibleSections(secondary).length > 0

export const isRailItemVisible = (item: AdminMenuItem) =>
  isVisible(item) && (!item.secondary || hasSecondaryContent(item.secondary))

export const resolveSecondaryDefault = (secondary: AdminMenuSecondary) =>
  visibleSections(secondary)
    .flatMap(section => section.items)
    .find(isNavigable)

// Only a section item has a panel to dock, everything else navigates away from whatever is open
export const resolveLandingKey = (item: AdminMenuItem | undefined) =>
  item?.secondary ? item.key : undefined

export const splitRailItems = (items: AdminMenuItem[], maxVisibleCount: number) => {
  if (items.length <= maxVisibleCount) {
    return { visibleItems: items, hiddenItems: [] }
  }

  const keptCount = Math.max(maxVisibleCount - 1, 0)

  return { visibleItems: items.slice(0, keptCount), hiddenItems: items.slice(keptCount) }
}
